module.exports = __webpack_public_path__ + "static/media/bg_top.60661ade.jpg";